import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  BusinessPersonTrainingRequirementAudit,
  BusinessPersonTrainingRequirementSkeleton
} from '../../../+models/training-requirement-audit.model';

@Component({
  selector: 'sd-portal-staff-member-audit-list',
  templateUrl: './staff-member-audit-list.component.html',
  styleUrls: ['./staff-member-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StaffMemberAuditListComponent implements OnInit {
  @Input() businessPersonTrainingRequirements: BusinessPersonTrainingRequirementSkeleton[];
  @Input() loading: boolean;
  @Input() audits: BusinessPersonTrainingRequirementAudit[];

  @Output() opened = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  onOpened(businessPersonTrainingRequirementId: number) {
    this.opened.emit(businessPersonTrainingRequirementId);
  }

  onNextPage(businessPersonTrainingRequirementId: number) {
    this.nextPage.emit(businessPersonTrainingRequirementId);
  }
}
